import gsap from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';

export default function Header() {
    // menu hider 
    let header = document.querySelector(".headermenu")

    const menuBG = gsap.from(header, {
        scrollTrigger: {
            // markers : true,
            start: 'top bottom',
            end: 'bottom top-=200', // bottom of the header is 200px away from top of viewport
            trigger: header,
            toggleClass: 'atTop',
            duration: 1,
            delay: 1
        }
    });

    const showMenu = gsap.from(header, { 
        yPercent: -100,
        paused: true,
        duration: 0.2
    }).progress(1);
    
    ScrollTrigger.create({
        invalidateOnRefresh : true,
        refreshPriority: 1,
        start: "top+=100 top", // top of the element +100px from the top of the viewport
        end: 99999,
        onUpdate: (self) => {
            self.direction === -1 ? showMenu.play() : showMenu.reverse()
        },
        onComplete: function(){
            menuBG.play();
        }
    });
}